module.exports = __webpack_public_path__ + "img/only_cake.52b31135.png";